<template>
  <div>
    <div class="row heading">
      <div class="col-md-6 col-10 offset-1 offset-md-3 col-10 offset-1 heading__content">
        <img src="../assets/images/syo-logo.png" alt class="heading__logo">
        <div class="heading__text">
          <p>Choose for a watch that looks like you! More than 65 shapes, with a unique design, a colorful watch thanks to Instagram profile. Enter your Instagram and swatch your own.</p>
        </div>
        <router-link to="swatch-my-own" class="heading__cta">let's start</router-link>
      </div>
    </div>
    <div class="row howItWorks">
      <div class="col-md-6 col-10 offset-1 offset-md-3 col-10 offset-1 howItWorks__content">
        <h2 class="howItWorks__title">How it works</h2>
        <div class="howItWorks__text">
          <ul>
            <li>1. Enter your Instagram username</li>
            <li>2. Choose your favorite photo Instagram</li>
            <li>3. Let the magic happen</li>
            <li>4.Your unique Swatch, personalized for you is finalized !</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row demo">
      <div class="col-12 demo__content">
        <div class="demo__mockup">
          <img src="../assets/images/mock-up.png" alt>
        </div>
        <div class="demo__modelsContainer isAnimated" ref="demo__modelsContainer">
          <div class="model">
            <img src="../assets/images/model-1.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-2.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-3.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-4.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-5.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-1.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-2.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-3.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-4.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-5.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-1.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-2.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-3.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-4.png" alt>
          </div>
          <div class="model">
            <img src="../assets/images/model-5.png" alt>
          </div>
        </div>
      </div>
    </div>
    <div class="row tryOut">
      <div class="col-md-6 col-10 offset-1 offset-md-3 col-10 offset-1 tryOut__content">
        <div class="tryOut__text">
          <p>Your watch. Your identity.</p>
          <p>No more waiting and discover how it will be !</p>
        </div>
        <router-link to="/swatch-my-own" class="tryOut__cta">Try now</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Homepage",
  data() {
    return {
      current: 0,
      interval: null,
      timeout: null
    };
  },
  mounted() {
    this.interval = setInterval(() => {
      this.current++;
      this.$refs.demo__modelsContainer.style.transform = `translate(calc(-50% - ${this
        .current * 400}px), -50%)`;
      if (this.current + 1 > 5) {
        setTimeout(() => {
          this.$refs.demo__modelsContainer.classList.remove("isAnimated");
          this.current = 0;
          this.$refs.demo__modelsContainer.style.transform = `translate(calc(-50% - ${this
            .current * 400}px), -50%)`;
          setTimeout(() => {
            this.$refs.demo__modelsContainer.classList.add("isAnimated");
          }, 100);
        }, 550);
      }
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>

<style scoped lang="scss">
@import "../assets/styles/helpers/utilities.scss";
.heading {
  background: $mainColor;
  background-image: url("../assets/images/header-bg.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  .heading__content {
    width: 100%;
    height: 100vh;
    min-height: 650px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .heading__logo {
      width: 50%;
      max-width: 500px;
      min-width: 250px;
    }
    .heading__text {
      margin-top: 30px;
      margin-bottom: 60px;
      color: white;
      line-height: 1.5em;
      font-size: 16px;
      text-align: center;
      font-family: $mainFont;
    }
    .heading__cta {
      color: white;
      padding: 20px 40px;
      background: $darkenColor;
      border-radius: 10px;
      text-transform: uppercase;
      text-decoration: none;
      filter: drop-shadow(1px 12px 24px rgba(black, 0.3));
      transition: transform 0.3s ease;
      transform: scale(1);
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
.howItWorks {
  .howItWorks__content {
    color: black;
    height: 350px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    .howItWorks__title {
      font-size: 45px;
      margin-bottom: 30px;
    }
    .howItWorks__text {
      line-height: 1.5em;
      font-size: 16px;
    }
  }
}
.demo {
  .demo__content {
    height: 450px;
    position: relative;
    overflow: hidden;
    &:after {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 0px;
      width: 100%;
      height: 50%;
      background: $mainColor;
      z-index: -1;
    }
    .demo__mockup {
      height: 100%;
      width: 245px;
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translateX(calc(-50% + 5px));
      z-index: 3;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .demo__modelsContainer {
      width: 6000px;
      height: 100%;
      text-align: center;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      will-change: transform;
      &.isAnimated {
        transition: 0.5s transform ease-in-out;
      }
      .model {
        width: 200px;
        height: 200px;
        border-radius: 100%;
        margin: 0px 100px;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 100%;
        }
      }
    }
  }
}
.tryOut {
  background: $mainColor;
  .tryOut__content {
    height: 600px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .tryOut__text {
      color: white;
      line-height: 1.5em;
      font-size: 16px;
      text-align: center;
      margin-bottom: 60px;
    }
    .tryOut__cta {
      color: white;
      padding: 20px 40px;
      background: $darkenColor;
      border-radius: 10px;
      text-transform: uppercase;
      text-decoration: none;
      filter: drop-shadow(1px 12px 24px rgba(black, 0.3));
      transition: transform 0.3s ease;
      transform: scale(1);
      &:hover {
        transform: scale(1.05);
      }
    }
  }
}
</style>
